import EntityModel        from '@/models/services/fondations/EntityModel';
import { Tag }            from '@/components/ui/tag';
import { Box }            from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HiCheck }        from 'react-icons/hi';

interface IEntityInfoBoxProps {
	entity: EntityModel;
}

const EntityInfoBox = ({ entity }: IEntityInfoBoxProps) => {
	const { t, i18n } = useTranslation();

	return (
		<Box
			backgroundColor="white"
			borderRadius="md"
			boxShadow="md"
			padding="20px"
			display="flex"
			flexDirection="column"
			gap="20px"
		>
			<Box display="flex" alignItems="center" gap="15px" flexWrap="wrap">
				<Text className="poppins-semibold" fontSize="22px" lineHeight="1">
					{entity.get('corporateName')}
				</Text>
				<Tag
					colorPalette={entity.entityStatus.color}
					startElement={entity.entityStatus.reference === 'ENABLED' ? <HiCheck /> : undefined}
					size="md"
				>
					{entity.entityStatus.getLabel(i18n.language)}
				</Tag>
			</Box>

			<Box
				display="grid"
				gridTemplateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
				gap="15px"
			>
				<Field label={t('pages.entity.info.corporateName')} value={entity.get('corporateName')} />
				<Field label={t('pages.entity.info.clientCode')} value={entity.get('clientReference') || '—'} />
				<Field label={t('pages.entity.info.website')} value={entity.get('website') || '—'} />
				<Field label={t('pages.entity.info.vatNumber')} value={entity.get('intraCommunityNumber') || '—'} />
				<Field label={t('pages.entity.info.siret')} value={entity.get('identificationNumber') || '—'} />
			</Box>
		</Box>
	);
};

export default EntityInfoBox;

const Field = ({ label, value }: { label: string; value: string }) => (
	<Box display="flex" flexDirection="column" gap="4px">
		<Text fontSize="12px" color="gray.500">{label}</Text>
		<Text fontSize="14px" fontWeight="600">{value}</Text>
	</Box>
);
